var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_615)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21432 0.377116C7.55676 0.642008 5.9958 1.33079 4.68283 2.37664C3.36987 3.42248 2.34948 4.78991 1.72065 6.34626C1.09181 7.90261 0.875871 9.59507 1.09377 11.2595C1.31168 12.9238 1.95603 14.5037 2.96432 15.8457L0.742895 18.23C0.623419 18.3581 0.543994 18.5183 0.51439 18.691C0.484786 18.8636 0.506294 19.0412 0.576269 19.2018C0.646244 19.3624 0.761633 19.499 0.908243 19.5949C1.05485 19.6908 1.22629 19.7417 1.40147 19.7414H10.3572C12.9168 19.7803 15.3939 18.8361 17.2782 17.1033C19.1625 15.3705 20.3105 12.981 20.4858 10.4271C20.5484 8.98305 20.2892 7.54312 19.7268 6.21159C19.1644 4.88006 18.3129 3.69025 17.2341 2.72831C16.1552 1.76637 14.876 1.05637 13.4889 0.649726C12.1019 0.24308 10.6418 0.149963 9.21432 0.377116Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon-comment.329a383b3ed39b3f058156182a5e10b7.svg";
export { ForwardRef as ReactComponent };